if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if( this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.disabled) return;
        if (this._variantChangeLocked) return;
        if (this.closest('product-info')?.pendingRequestUrl) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        //check if subscription or one-timer
        if (this.classList.contains('separate-products')) {
          this.separateProductsLogic();
        }

        // Free boosters logic
        this.freeBoostersLogic();

        const formData = new FormData(this.form);

         // Add purchase type property based on selling plan
         const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
         const purchaseType = sellingPlanInput && !sellingPlanInput.disabled ? 'subscription' : 'onetimer';
         formData.append('properties[_purchase_type]', purchaseType);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const quickAddModalSwitch = this.closest('quick-add-modal');
        let UID = null;

        if (quickAddModalSwitch && quickAddModalSwitch.classList.contains('switcher')) {
          UID = await this.removeSwitchingProduct(quickAddModalSwitch);
        }

        await fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description, response.status);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

             const birthdayWillApply =
              window.BirthdaySalePDP &&
              BirthdaySalePDP.isActive() &&
              !(typeof BirthdaySalePDP.isInfoMode === 'function' && BirthdaySalePDP.isInfoMode()) &&
              !(typeof BirthdaySalePDP.isCodeDismissed === 'function' && BirthdaySalePDP.isCodeDismissed());

            if (birthdayWillApply) {
              document.documentElement.setAttribute('data-birthday-applying-code', '1');
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            if (
              window.BirthdaySalePDP &&
              BirthdaySalePDP.isActive() &&
              typeof BirthdaySalePDP.applyCodeAfterCartAdd === 'function'
            ) {
              BirthdaySalePDP.applyCodeAfterCartAdd(this);
            } else if (
              window.BirthdaySalePDP &&
              BirthdaySalePDP.isActive() &&
              typeof BirthdaySalePDP.applyCodeForActiveState === 'function'
            ) {
              const cartUrl = (window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js';
              fetch(cartUrl, { cache: 'no-store' })
                .then((r) => r.json())
                .then((cart) => BirthdaySalePDP.applyCodeForActiveState(cart, null));
            } else if (
              window.BirthdaySalePDP &&
              BirthdaySalePDP.isActive() &&
              typeof BirthdaySalePDP.applyCodeToCart === 'function'
            ) {
              const birthdayCode = BirthdaySalePDP.getCode();
              if (birthdayCode) {
                BirthdaySalePDP.applyCodeToCart(birthdayCode);
              }
            }

            const quickAddModal = this.closest('quick-add-modal') || this.closest('modal-dialog') || this.closest('product-image-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // Gifts logic
              this.handleGiftLogic(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.removeLoading(this);
            this.updatePDPForm();
          });

        if (UID && UID.parentUID) {
          await this.updatePropertiesAfterSwitchingProduct(quickAddModalSwitch, UID.parentUID)
        }

        if (this.dataset.id.includes('GiftsProductForm')) {
          if (typeof CartItems !== 'undefined' && typeof CartItems.cartDrawerRenderContent === 'function') {
            CartItems.cartDrawerRenderContent();
          }
          const giftModal = this.closest('modal-dialog') || this.closest('product-image-modal');
          if (giftModal) {
            giftModal.hide();
          }

          this.removeLoading(this);
        }
      }

      removeLoading($this) {
        $this.submitButton.classList.remove('loading');
        if ($this.cart && $this.cart.classList.contains('is-empty')) $this.cart.classList.remove('is-empty');
        if (!$this.error) $this.submitButton.removeAttribute('aria-disabled');
        if ($this.dataset.id.includes('GiftsProductForm')) $this.submitButton.removeAttribute('aria-disabled');
        $this.querySelector('.loading__spinner').classList.add('hidden');
      }

      updatePDPForm() {
        const productWrapper = document.querySelector('product-info');
        if (!productWrapper) return;

        const sectionId = productWrapper.id.replace('MainProduct-', '');
        const container = document.querySelector('.product__buy-buttons');
        if (!container) return;

        // Capture current picker state BEFORE the swap — variant-selects lives
        // outside .product__buy-buttons, so its DOM survives, but the freshly
        // rendered product-form inside always comes back as "first variant +
        // subscription". We need to reconcile the two after the innerHTML swap.
        const variantSelects = productWrapper.querySelector('variant-selects');
        const currentType =
          variantSelects?.querySelector('plan-picker-september')?.dataset?.currentType ||
          variantSelects?.querySelector('plan-picker-menobacs')?.dataset?.currentType ||
          variantSelects?.querySelector('plan-picker-simplified-v1')?.dataset?.currentType ||
          variantSelects?.querySelector('plan-picker-v2-ab')?.dataset?.currentType ||
          variantSelects?.planPicker?.dataset?.currentType ||
          productWrapper.querySelector('.plan-picker')?.dataset?.currentType ||
          'subscription';

        // Products that combine a variant-type picker (e.g. protein flavor) with
        // a plan picker should trigger the gifts popup for every variant, so the
        // onetimer-disables-gifts reconciliation below is skipped for them.
        const giftsAlwaysEnabled = !!(
          (variantSelects?.variantTypePicker || productWrapper.querySelector('.variant-type-picker')) &&
          (variantSelects?.planPicker || productWrapper.querySelector('.plan-picker'))
        );

        const currentVariantId = container.querySelector('input[name="id"]')?.value;
        const params = new URLSearchParams(window.location.search || '');
        if (currentVariantId) params.set('variant', currentVariantId);
        params.set('section_id', sectionId);
        const url = `${window.location.pathname}?${params.toString()}`;

        const oldPriceWrap = container.querySelector('.selected-variant-price');
        const oldPriceWrapHTML = oldPriceWrap ? oldPriceWrap.innerHTML : null;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const buyButtons = html.querySelector('.product__buy-buttons');
            if (!buyButtons) return;

            const esReverted = !!container.closest('product-info')?.querySelector('plan-picker-menobacs-es[data-es-reverted]');
            const onetimeEl = container.querySelector('[data-menobacs-onetime]');
            const infoRow = container.querySelector('[data-menobacs-info]');

            container.innerHTML = buyButtons.innerHTML;

            const newSubmitButton = container.querySelector('[type="submit"]');
            if (esReverted) {
              if (onetimeEl) {
                container.insertAdjacentElement('beforebegin', onetimeEl);
                onetimeEl.classList.add('menobacs-onetime--above');
              }
              if (infoRow && newSubmitButton) {
                newSubmitButton.insertAdjacentElement('afterend', infoRow);
              }
            } else if (onetimeEl && newSubmitButton) {
              newSubmitButton.insertAdjacentElement('afterend', onetimeEl);
            }

            if (oldPriceWrapHTML != null) {
              const newPriceWrap = container.querySelector('.selected-variant-price');
              if (newPriceWrap) newPriceWrap.innerHTML = oldPriceWrapHTML;
            }

            // Re-apply purchase type: the server always renders selling_plan
            // enabled (subscription). If the user was on onetimer, disable it
            // and re-run togglePrices so the ATC button matches the picker.
            const newProductForm = container.querySelector('product-form');
            if (!newProductForm) return;

            const sellingPlanInput = newProductForm.querySelector('input[name="selling_plan"]');
            if (sellingPlanInput) {
              if (currentType === 'onetimer') {
                sellingPlanInput.setAttribute('disabled', 'disabled');
              } else {
                sellingPlanInput.removeAttribute('disabled');
              }
            }

            const giftsInput = newProductForm.querySelector('input[name="properties[_gifts]"][data-requires-subscription]');
            if (giftsInput) {
              if (currentType === 'onetimer' && !giftsAlwaysEnabled) {
                giftsInput.setAttribute('disabled', 'disabled');
              } else {
                giftsInput.removeAttribute('disabled');
              }
            }

            if (typeof newProductForm.togglePrices === 'function') {
              newProductForm.togglePrices();
            }

            if (window.BirthdaySalePDP && typeof BirthdaySalePDP.syncAll === 'function' && BirthdaySalePDP.isActive()) {
              window.BirthdaySalePDP.syncAll();
            }

            if (window.CampaignSegmentation && typeof window.CampaignSegmentation.applyVisualPriceDiscount === 'function') {
              const appliedDiscount = window.CampaignSegmentation.getAppliedDiscount?.();
              if (appliedDiscount && appliedDiscount.percent > 0) {
                window.CampaignSegmentation.applyVisualPriceDiscount(appliedDiscount.percent, appliedDiscount.code);
              }
            }
          });
      }

      async removeSwitchingProduct(modal) {
        return new Promise(async (resolve, reject) => {
          try {
            const cart = await AjaxCart.getCart();
            let quickAddProductId = modal.id.replace('QuickAdd-drawer-', '');
            let upd = {}
            let parentUID = null;

            cart.items.forEach(item => {
              if (item.product_id == quickAddProductId && !item.selling_plan_allocation) {
                upd = { [`${item.key}`]: 0 }

                if (item.properties._parent_uid) {
                  parentUID = item.properties._parent_uid;
                }
              }
            });

            cart.items.forEach(item => {
              if (item.properties?._uid == parentUID) {
                upd = {...upd, [`${item.key}`]: 0 };
              }
            });

            upd = { updates: upd }

            if (Object.keys(upd).length) {
              let body = JSON.stringify(upd);

              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }}).then((response) => {
                return response.json();
              })
              .then((state) => {
                resolve({ parentUID });
              })
              .catch((e) => {
              });
            } else {
              resolve(null);
            }
          } catch (error) {
            reject(error);
          }
        });
      }

      async updatePropertiesAfterSwitchingProduct(modal, parentUID) {
        const cart = await AjaxCart.getCart();
        let quickAddProductId = modal.id.replace('QuickAdd-drawer-', '');
        let itemKey = null;

        cart.items.forEach(item => {
          if (item.product_id == quickAddProductId) {
            itemKey = item.key;
          }
        });

        let body = JSON.stringify({
          id: itemKey,
          properties: {
            _parent_uid: parentUID,
          }
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }}).then((response) => {
          return response.json();
        })
        .catch((e) => {
        });
      }

      handleGiftLogic (data) {
        const septemberPicker =
          this.closest('product-info')?.querySelector('plan-picker-september') ||
          document.querySelector('plan-picker-september');
        const autoSelectGift = this.dataset.autoSelectGift === 'true' || !!septemberPicker;
        
        if (data.items && data.items.length) {
          let bundles = [53974170009868, 53974170632460, 53974162768140, 54165953806604, 54165956690188, 54165960491276, 53974170730764, 53974174204172, 53974170108172, 53974173647116];
          let bundleItem = false;

          data.items.forEach(item => {
            if (bundles.includes(item.id)) {
              bundleItem = item;
            }
          });

          if (bundleItem != false && !autoSelectGift) {
            const giftModal = document.getElementById(`PopupModal-Gifts-${bundleItem.product_id}`) || false;

            if (giftModal) giftModal.show();
          } else {
            // When auto-selecting gifts, fetch fresh cart data and open drawer
            if (autoSelectGift && this.cart.tagName === 'CART-DRAWER') {
              CartItems.cartDrawerRenderContent();
            } else {
              this.cart.renderContents(data);
            }
          }
        } else {
          if (data?.properties?._gifts && !autoSelectGift){
            const giftModal = document.getElementById(`PopupModal-Gifts-${data?.properties?._parent_uid}`) || false;
            if (giftModal) giftModal.show();
          } else {
            // When auto-selecting gifts, fetch fresh cart data and open drawer
            if (autoSelectGift && this.cart.tagName === 'CART-DRAWER') {
              CartItems.cartDrawerRenderContent();
            } else {
              this.cart.renderContents(data);
            }
          }
        }
      }

      freeBoostersLogic() {
        const freeBoostersComponent = document.querySelector('free-boosters');
        const freeBoostersInput = document.querySelector('#free-boosters-input-id');
        const freeBoostersDisabledInputs = document.querySelectorAll('.free-boosters-input');

        if (freeBoostersComponent && freeBoostersInput && freeBoostersDisabledInputs) {
          freeBoostersInput.value = freeBoostersComponent.getActiveItemVariantId();

          if (freeBoostersInput.value != 'false') {
            freeBoostersDisabledInputs.forEach(item => {
              item.removeAttribute('disabled');
            });
          } else {
            freeBoostersDisabledInputs.forEach(item => {
              item.setAttribute('disabled', 'disabled');
            });
          }
        }
      }

      handleErrorMessage(errorMessage = false, statusCode = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }else {
          return;
        }

        if (statusCode == 422) {
          const globalValidationModal = document.getElementById('GlobalValidationModal');
          const errorMessageEl = globalValidationModal?.querySelector('.validation-message');

          if (globalValidationModal && errorMessageEl) {
            errorMessageEl.querySelector('.cart-item__error-text').innerHTML = errorMessage;
            globalValidationModal.openModal();
          }
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.submitButton = this.querySelector('[type="submit"]') || this.submitButton;
        if (!this.submitButton) return;
        this.submitButtonText = this.submitButton.querySelector('span') || this.submitButtonText;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }

        this._variantChangeLocked = false;
        this._submitDisabledBeforeLock = false;

        this.togglePrices();
      }

      lockForVariantChange() {
        this.submitButton = this.querySelector('[type="submit"]') || this.submitButton;
        if (!this.submitButton) return;
        if (!this._variantChangeLocked) {
          this._submitDisabledBeforeLock = this.submitButton.hasAttribute('disabled');
          this._variantChangeLocked = true;
        }
        this.submitButton.setAttribute('disabled', 'disabled');
      }

      unlockForVariantChangeIfIdle() {
        if (!this._variantChangeLocked) return;
        this._variantChangeLocked = false;
        if (this._submitDisabledBeforeLock) {
          this._submitDisabledBeforeLock = false;
          return;
        }
        this._submitDisabledBeforeLock = false;
        this.toggleSubmitButton(false);
      }

      togglePrices() {
        const sellingPlanInput = this.querySelector('input[name="selling_plan"]') || false;
        const mainPrice =  this.submitButton.querySelector('.atc-price_main') || false;
        const basePrice = this.querySelector('.base__price span') || false;
        const v1Price = document.querySelector('.selected-variant-price-v1 .atc-price_main-v1') || false;

        const variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) return;

        const isInfluencer = variantSelects.isInfluencer[0];
        const selectPrice = variantSelects.selectedCurrentOption[0];
        const selectPriceOnetime = variantSelects.selectedCurrentOptionOnetime[0];

        if (isInfluencer == 'true') {
          if(sellingPlanInput && mainPrice) {
            sellingPlanInput.hasAttribute('disabled')
              ? mainPrice.innerHTML = `<span style="text-decoration: line-through; margin-right: 8px; font-size: 90%; opacity: 0.5;">${selectPriceOnetime}</span>` + mainPrice.dataset?.onetimerPrice
              : mainPrice.innerHTML = `<span style="text-decoration: line-through; margin-right: 8px; font-size: 90%; opacity: 0.5;">${selectPrice}</span>` + mainPrice.dataset?.subscriptionPrice;

            if (v1Price) {
              sellingPlanInput.hasAttribute('disabled')
                ? v1Price.innerHTML = `<span class="fw-400" style="color: #000413; text-decoration: line-through; margin-right: 8px; font-size: 90%; opacity: 0.5;">${selectPriceOnetime}</span>` + mainPrice.dataset?.onetimerPrice
                : v1Price.innerHTML = `<span class="fw-400" style="color: #000413; text-decoration: line-through; margin-right: 8px; font-size: 90%; opacity: 0.5;">${selectPrice}</span>` + mainPrice.dataset?.subscriptionPrice;
            }
          }

          if (sellingPlanInput && basePrice) {
            sellingPlanInput.hasAttribute('disabled')
              ? basePrice.innerHTML = basePrice.dataset?.onetimerBasePrice
              : basePrice.innerHTML = basePrice.dataset?.subscriptionBasePrice;
          }
        } else {
          if(sellingPlanInput && mainPrice) {
            sellingPlanInput.hasAttribute('disabled') ? mainPrice.innerHTML = mainPrice.dataset?.onetimerPrice :  mainPrice.innerHTML = mainPrice.dataset?.subscriptionPrice;
          }

          if (sellingPlanInput && basePrice) {
            sellingPlanInput.hasAttribute('disabled') ? basePrice.innerHTML = basePrice.dataset?.onetimerBasePrice :  basePrice.innerHTML = basePrice.dataset?.subscriptionBasePrice;
          }
        }
      }

      separateProductsLogic() {
        let planPicker =
          document.querySelector('variant-selects')?.planPicker ||
          document.querySelector('plan-picker-september, plan-picker-menobacs, plan-picker-simplified-v1, .plan-picker, plan-picker-v2-ab');
        let separateProductInputs = this.querySelectorAll('.separate-products-input');
        let notSeparateProductInput = this.querySelector('.not-separate-products-input');

        if (planPicker && separateProductInputs.length) {
          if (planPicker.dataset.currentType === 'onetimer') {
            separateProductInputs.forEach((input, index) => {
              input.removeAttribute('disabled');
            });

            notSeparateProductInput ? notSeparateProductInput.setAttribute('disabled', 'disabled') : false;
          } else {
            separateProductInputs.forEach((input, index) => {
              input.setAttribute('disabled', 'disabled');
            });

            notSeparateProductInput ? notSeparateProductInput.removeAttribute('disabled') : false;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
